import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';
import { NomineeCustomer } from './response/NomineeCustomer';

export const nomineeCustomerSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    nomineeCustomers: builder.query<NomineeCustomer[], void>({
      query: () => Paths.NomineeCustomer,
      providesTags: ['nominee_customers'],
    }),
    createNomineeCustomer: builder.mutation<
      NomineeCustomer,
      Omit<NomineeCustomer, 'id'>
    >({
      query: (data) => ({
        url: Paths.NomineeCustomer,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['nominee_customers'],
    }),
    updateNomineeCustomer: builder.mutation<NomineeCustomer, NomineeCustomer>({
      query: (data) => ({
        url: Paths.NomineeCustomer,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['nominee_customers'],
    }),
    deleteNomineeCustomer: builder.mutation<
      void,
      { nomineeCustomerId: number }
    >({
      query: (data) => ({
        url: Paths.NomineeCustomer,
        method: 'DELETE',
        params: { nomineeCustomerId: data.nomineeCustomerId },
      }),
      invalidatesTags: ['nominee_customers'],
    }),
  }),
});

export const {
  useNomineeCustomersQuery,
  useCreateNomineeCustomerMutation,
  useUpdateNomineeCustomerMutation,
  useDeleteNomineeCustomerMutation,
} = nomineeCustomerSlice;
